var map = {
	"./applepay_2024_10_23.svg": 1084,
	"./bancontact_2024_10_23.svg": 1085,
	"./belfius.svg": 1086,
	"./biller.svg": 1087,
	"./billie_2024_10_23.svg": 1088,
	"./blik.svg": 1089,
	"./bnpl-light.svg": 1090,
	"./buyer_associations/prisma.avif": 1091,
	"./buyer_associations/soennecken.svg": 1092,
	"./cartes_bancaires_2024_10_23.svg": 1093,
	"./creditcard.svg": 1094,
	"./eps.svg": 1095,
	"./giropay.svg": 1096,
	"./hokodo_2024_10_23.svg": 1097,
	"./ideal_2024_10_23.svg": 1098,
	"./inghomepay.svg": 1099,
	"./kbc.svg": 1100,
	"./mastercard.svg": 1101,
	"./mobilepay.svg": 1102,
	"./mondu.svg": 1103,
	"./paypal_2024_10_23.svg": 1104,
	"./przelewy24.svg": 1105,
	"./sepa_2024_10_23.svg": 1106,
	"./sofort.svg": 1107,
	"./supplier_authorization.svg": 1108,
	"./test.svg": 1109,
	"./visa.svg": 1110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 825;